// assets/ajaxinate-init.js

let ajaxinateInstance = null;

function initializeAjaxinate() {
  const container = document.querySelector('.collection-products');
  const pagination = document.querySelector('.pagination');

  if (container && pagination && typeof Ajaxinate !== 'undefined') {
    if (ajaxinateInstance) {
      ajaxinateInstance.destroy();
    }

    ajaxinateInstance = new Ajaxinate({
  container: '#AjaxinateLoop',
  pagination: '#AjaxinatePagination',
  method: 'scroll',
  offset: 100,
  callback: function(response) {
    console.log('Ajaxinate: New items loaded!', response);
  }
});
  }
}

document.addEventListener('DOMContentLoaded', initializeAjaxinate);
document.addEventListener('collection:updated', initializeAjaxinate);